import { all } from "redux-saga/effects";
import auth from "./auth/auth.saga";
import user from "./user/user.saga";
import deparment from "./department/department.saga";

export default function* rootSaga() {
  yield all([auth(), user(), deparment()]);
}
